import { render } from "./App.vue?vue&type=template&id=a788c808&lang=pug"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a788c808&lang=scss"

import exportComponent from "/Users/sellerofhappiness/WORK/VUE/CORAL VUE/components-store-v2/AUTH-FORM-CARD/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__